import { Radio, RadioChangeEvent } from 'antd';
import React, { FC } from 'react';
import { FrequencyDates } from 'shared/enums/news';
import style from './index.module.scss';

type TProps = {
  retry: FrequencyDates;
  onChange: (data: FrequencyDates) => void;
};

const Frequency: FC<TProps> = ({ retry, onChange }) => {
  const onFrequencyChange = (e: RadioChangeEvent) => {
    onChange(e.target.value);
  };

  return (
    <div className={style.frequency}>
      <h4>Периодичность публикации:</h4>
      <Radio.Group onChange={onFrequencyChange} value={retry} style={{ display: 'flex', flexDirection: 'column' }}>
        <Radio value={FrequencyDates.ONCE}>{FrequencyDates.ONCE}</Radio>
        <Radio value={FrequencyDates.WEEKLY}>{FrequencyDates.WEEKLY}</Radio>
        <Radio value={FrequencyDates.DATES}>{FrequencyDates.DATES}</Radio>
      </Radio.Group>
    </div>
  );
};

export default Frequency;
